import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { IosPage } from "mobile/components/IosParity";
import MobileTopBar from "mobile/components/MobileTopBar";

export default function MobilePage({ title, subtitle, right, children, onBack }) {
  const navigate = useNavigate();
  const handleBack = onBack || (() => navigate("/m/dashboard"));
  return (
    <IosPage>
      <MobileTopBar title={title} subtitle={subtitle} onBack={handleBack} right={right} />
      {children}
    </IosPage>
  );
}

MobilePage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  right: PropTypes.node,
  children: PropTypes.node,
  onBack: PropTypes.func,
};
MobilePage.defaultProps = {
  subtitle: "",
  right: null,
  children: null,
  onBack: null,
};
